import React from 'react';
import { TypeDropdown } from '../../type-dropdown/TypeDropdown';

export const TypeFilter = ({ typeConfig, updateFilter, value }) => {
    const { label, options } = typeConfig;
    return (
        <TypeDropdown
            label={label}
            options={options}
            onChange={updateFilter}
            value={value}
        />
    );
};
